// Ring buffer for averaging a set of samples.
export class SampleRing {

  /** @type {number} Maximum number of samples stored */
  #size;
  /** @type {Float32Array} */
  #samples;
  /** @type {number} Current number of samples stored */
  #count;
  /** @type {number} Index of the next sample */
  #next;

  /**
   * @param {number} size
   */
  constructor(size) {
    this.#size = size;
    this.#samples = new Float32Array(size);
    this.#count = 0;
    this.#next = 0;
  }

  /**
   * @param {number} sample
   */
  addSample(sample) {
    this.#samples[this.#next] = sample;

    this.#next++;
    if (this.#next >= this.#count) {
      this.#next = 0;
    }

    if (this.#count < this.#size) {
      this.#count++;
    }
  }

  /**
   * The mean of all samples in the ring.
   * @returns {number}
   */
  mean() {
    let sum = 0;
    for (let i = 0; i < this.#count; i++) {
      sum += this.#samples[i];
    }
    return sum / this.#count;
  }

  /**
   * The value of the last sample added.
   * @returns {number}
   */
  last() {
    if (this.#count === 0) {
      return 0;
    }
    const prev = (this.#next - 1 + this.#count) % this.#count;
    return this.#samples[prev];
  }
}